<template>
  <div id="app">
    <v-app>
      <v-content>
        <v-container>
          <h1 id="top">QuickChords Collections <img style="height: 50px" src="../assets/quickchords.png"/></h1>
          <p>
            This site contains {{titleCount}} public QuickChords documents (chord charts and lyric sheets) organized by
            collections.
            Click on any song link to <strong>view a transposable chord chart with optional chord diagrams</strong>,
            or an <strong>auto-sizing lyric sheet</strong>.
          </p>

          <div style="display: none"> Items in this directory are not contained in the QuickChords database,
            but can be imported into your QuickChords account by
            clicking on a link, modifying as needed, and then saving to your personal library.

          </div>

          <label>
            <div v-if="searchTitle.length > 0">Search Titles</div>
            <input ref="searchTitle" class="search" placeholder="Search titles" style="width: 100%; margin-bottom: 8px"
                   v-model="searchTitle"
                   type="text"/>
          </label>
          <label>
            <div v-if="searchArtist.length > 0">Search Artists</div>
            <input class="search" placeholder="Search artists" style="width: 100%" v-model="searchArtist" type="text"/>
          </label>
          <a v-if="searchTitle || searchArtist" @click.prevent="onReset">Reset Search</a>

          <div v-if="searchTitle.length > 0 && filteredCollections.length === 0">
            Chart not found? You can try to
            <v-btn small href="#" @click="onUgImport(searchTitle, searchArtist)"> Import Chart
              {{searchTitle}} From Ultimate Guitar
            </v-btn>
            <v-btn small href="#" @click="onWikiaImport({title:searchTitle, artist:searchArtist})"> Import Lyrics
              {{searchTitle}} From Wikia
            </v-btn>
            .
          </div>

          <h1>Collections</h1>
          <template v-if="!isFiltering || resultsFound">
            <div class="chip" v-for="collection in filteredCollections" :key="collection.title"
                 @click="onCollectionClick(collection)">
              <span class="avatar">{{collection.items.length}}</span>
              {{collection.title}}
            </div>
            <hr/>
            <Collections :collections="filteredCollections" @search-wikia="onWikiaImport"/>
          </template>

          <div v-else>
            <h2>No Search Results Were Found In Our Main Database
            </h2>
          </div>

          <template v-if="searchTitle.length > 4 && resultsFound < 4">
            <hr style="margin: 20px"/>
            <div class="title">Results for <strong>{{searchTitle}}</strong> are <span v-if="resultsFound">also</span>
              available to search and import from external sources.</div>
            <br/>
            <v-btn small @click="onUgImport(searchTitle, searchArtist)">Import Chart And View Now</v-btn>
            <v-btn small @click="onWikiaImport({title:searchTitle, artist:searchArtist})">Import Lyrics And View Now
            </v-btn>
          </template>

          <hr/>

          <p>
            If you would like to contribute additional songs or collections, please send us an <a
            href="mailto:info@quickchords.org?subject=QuickChords-Collections+inquiry" target="_blank">email</a>.
          </p>
          <p>
            Did not find what you were looking for?
            Try to
            <a href="#"
               @click="onImport">Import</a> or
            <a href="#"
               @click="onCreate">Create
              Your Own</a>.
          </p>

        </v-container>
        <ImportDialog ref="importDialog"/>
        <CreateDialog ref="createDialog"/>
      </v-content>
    </v-app>
    <UGSearch ref="searchUG" :proxy-url="proxyUrl"/>
    <WikiaSearch ref="searchWikia" :proxy-url="proxyUrl"/>
  </div>
</template>

<script>
  import Collections from "./Collections";
  import ImportDialog from "./ImportDialog";
  import CreateDialog from "./CreateDialog";
  import UGSearch from "./UGSearch";
  import WikiaSearch from "./WikiaSearch";
  import QcUtil from '/Users/steven/dev/projects/other/quickchords-vue/src/util/util-qc.js'
  import {getDocumentField} from '/Users/steven/dev/projects/other/quickchords-vue/src/util/document.js'

  const proxyUrl = 'https://www.quickchords.org:9999'

  function match(q, value) {
    return value.toLowerCase().indexOf(q.toLowerCase()) >= 0
  }

  export default {
    name: 'app',
    components: {
      WikiaSearch,
      UGSearch,
      CreateDialog,
      ImportDialog,
      Collections,
    },
    data: () => ({
      searchTitle: '',
      searchArtist: '',
      collections: require('../data/db').default,
      snackbar: false,
    }),
    methods: {
      onCollectionClick(collection) {
        location.hash = `#${collection.title}`
      },
      onReset() {
        this.searchTitle = ''
        this.searchArtist = ''
      },
      onImport() {
        this.$refs.importDialog.show()
        this.$gtag('click', 'open', 'collection:import')
      },
      onCreate() {
        this.$refs.createDialog.show()
        this.$gtag('click', 'open', 'collection:create')
      },
      onUgImport(title, artist) {
        this.$gtag('click', 'import', 'collections:open:import-chords:ug')
        this.$refs.searchUG.pickFile({
          title,
          artist,
          autoSubmit: true
        }).then(result => {
          this.$gtag('click', 'import', 'collections:import:import-chords:ug')
          this._sendEmbedded({
            flavor: 'chords',
            collection: '0',
            artist: getDocumentField('quickchords', result, 'artist', artist),
            title: getDocumentField('quickchords', result, 'title', title),
            source: 'ug',
            embed: result,
          })
        })
      },
      onWikiaImport(song) {
        const {title, artist} = song
        this.$gtag('click', 'import', 'collections:open:import-lyrics:wikia')
        this.$refs.searchWikia.pickFile({
          title,
          artist,
          autoSubmit: true
        }).then(result => {
          const url = QcUtil.makeCreatorLink({
            flavor: 'lyrics',
            collection: '0',
            artist: getDocumentField('quickchords', result, 'artist', artist),
            title: getDocumentField('quickchords', result, 'title', title),
            source: 'wikia',
            embed: result
          })
          this.$gtag('click', 'import', 'collections:import:import-lyrics:wikia')
          window.open(url, '_self')
        })
      },
      _sendEmbedded(params) {
        const url = QcUtil.makeCreatorLink(params)
        window.open(url, '_self')
      }
    },
    async mounted() {
      await this.$nextTick()
      this.$refs.searchTitle.focus()
      const action = require('/Users/steven/dev/projects/other/quickchords-vue/src/util/getParameterByName.js').default('action')
      switch (action) {
        case 'import':
          this.onImport()
          break;
        case 'create':
          this.onCreate()
          break;
      }
    },
    watch: {},
    computed: {
      titleCount() {
        return this.collections.map(it => it.items.length).reduce((a, b) => a + b)
      },
      isFiltering() {
        return this.searchTitle.length > 0 || this.searchArtist.length > 0
      },
      filteredCollections() {
        if (!this.isFiltering) {
          return this.collections
        } else {
          const filtered = this.collections.map(it => {
            let found = it.items;
            if (this.searchTitle.length > 0) {
              found = found.filter(it => match(this.searchTitle, it.title))
            }
            if (this.searchArtist.length > 0) {
              found = found.filter(it => match(this.searchArtist, it.artist))
            }
            return {
              title: it.title,
              items: found
            }
          })
          const count = filtered.reduce((acc, it) => acc + it.items.length, 0)
          this.$gtag('query', 'collections', `${this.searchTitle}:${this.searchArtist}`, count)
          return filtered.filter(it => it.items.length > 0)
        }
      },
      resultsFound() {
        return this.filteredCollections.find(it => it.items.length > 0) !== undefined
      }
      ,
      proxyUrl() {
        return proxyUrl
      }
    }
  }
</script>

<style lang="scss">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    /*margin-top: 60px;*/
    max-width: 800px;
  }

  .search {
    font-size: 18px;
    background-color: #e4e4e4;
    padding-left: 6px;
  }

  .chip {
    display: inline-block;
    padding: 0 25px;
    height: 50px;
    font-size: 16px;
    line-height: 50px;
    border-radius: 25px;
    background-color: #f1f1f1;
    border: 1px solid silver;
    cursor: pointer;
  }

  .chip .avatar {
    font-size: 10px;
    font-weight: bold;

    float: left;
    margin: 0 10px 0 -25px;
    height: 25px;
    width: 25px;
    border-radius: 50%;
    background-color: #0000f226;
  }

  .chip {
    margin: 6px;
    height: 25px;
    line-height: 25px;
    background-color: #ebebeb;
    border: 1px solid silver;
  }

</style>
